<template>
    <div v-if="_g_IsUserLogged && (user_has_closed != 'true') && banner_settings.status == 1" class="banner-container">
        <div class="banner-container" :style="{ backgroundColor: banner_settings.color }">
            <p class="text-banner-mobile" v-html="banner_settings.message"></p>
            <span class="material-icons-outlined" style="font-size:16px;" @click="_closeBanner()">close</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import APICaller from "@/components/codeComponents/APICaller.js";

export default {
  name: 'PromoPopUp',
  mixins: [APICaller],
  props: {
    banner_settings: {
      type: Object,
      default: () => ({
        status: 0,
        message: '',
        color: '#D8AB18'
      })
    }
  },
  data() {
    return {
      user_has_closed: 'true',
    };
  },
  watch: {
    
  },
  mounted() {
    var bannerInterval = setInterval(() => {
      if (this._g_UserId != undefined && this._g_UserId != 0 && this._g_UserId != null) {
        this._getIfUserClosedBanner();
        clearInterval(bannerInterval);
      }
    }, 250);
  },
  computed: {
    ...mapGetters(['_g_IsUserLogged', '_g_UserId'])
  },
  methods: {
    _getIfUserClosedBanner: function(){
      this.user_has_closed = sessionStorage.getItem('masterclass-banner');
    },

    _closeBanner: function(){
      this.user_has_closed = "true"
      sessionStorage.setItem('masterclass-banner', 'true');
    }
  },
}
</script>

<style lang="scss">
.banner-container{
  display: flex;
  align-items: center;
  justify-content: center;
}
.text-banner-mobile{
  font-size: 10px;
  width: 100%;
  margin-left: 5px;
  color: white;
}
</style>
